var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29279 1.29357C1.48031 1.1061 1.73462 1.00078 1.99979 1.00078C2.26495 1.00078 2.51926 1.1061 2.70679 1.29357L7.99979 6.58657L13.2928 1.29357C13.385 1.19806 13.4954 1.12188 13.6174 1.06947C13.7394 1.01706 13.8706 0.989473 14.0034 0.988319C14.1362 0.987165 14.2678 1.01247 14.3907 1.06275C14.5136 1.11303 14.6253 1.18728 14.7192 1.28117C14.8131 1.37507 14.8873 1.48672 14.9376 1.60962C14.9879 1.73251 15.0132 1.86419 15.012 1.99697C15.0109 2.12975 14.9833 2.26097 14.9309 2.38297C14.8785 2.50498 14.8023 2.61532 14.7068 2.70757L9.41379 8.00057L14.7068 13.2936C14.8889 13.4822 14.9897 13.7348 14.9875 13.997C14.9852 14.2592 14.88 14.51 14.6946 14.6954C14.5092 14.8808 14.2584 14.986 13.9962 14.9882C13.734 14.9905 13.4814 14.8897 13.2928 14.7076L7.99979 9.41457L2.70679 14.7076C2.51818 14.8897 2.26558 14.9905 2.00339 14.9882C1.74119 14.986 1.49038 14.8808 1.30497 14.6954C1.11956 14.51 1.01439 14.2592 1.01211 13.997C1.00983 13.7348 1.11063 13.4822 1.29279 13.2936L6.58579 8.00057L1.29279 2.70757C1.10532 2.52004 1 2.26573 1 2.00057C1 1.73541 1.10532 1.4811 1.29279 1.29357Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.baf034fa9965388e431a04358ded89d4.svg";
export { ForwardRef as ReactComponent };